/**
 * The backend no longer forces addon-tagged lines to render last — line-item order is
 * whatever the FE submits. Reconstruct the addon-last grouping here (stable otherwise)
 * so every create/update flow across Orders and Estimates produces the same ordering
 * before `sortOrder` gets assigned by array position.
 */
export function sortLineItemsAddonLast<T extends { type?: string; isAddonItem?: boolean }>(items: T[]): T[] {
  const isAddon = (li: T) => (li.type === 'addon' || li.isAddonItem ? 1 : 0);
  return [...items].sort((a, b) => isAddon(a) - isAddon(b));
}
